import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { CertificadoAtencionBreadCrumb } from "./ingreso/CertificadoAtencionBreadCrumb";
import { CertificadoAtencionIngreso } from "./ingreso/CertificadoAtencionIngreso";
import { CertificadoAtencionBusqueda } from "./consulta/CertificadoAtencionBusqueda";
import { MENU_CERTIFICADO_ATENCION } from "../../../utils/constants";
import { cleanAfiliadoSeleccionado, clearReducer } from "../../../actions/certificadoAtencion/certificadoAtencionActions";
import { useDispatch } from "react-redux";

const style = {
    root: {
        flexGrow: 1,
    },
};

export const CertificadoAtencion = (props) => {


    const dispatch = useDispatch();
    const [activeBreadcrumb, setActiveBreadcrumb] = useState();

    const resetRouteStateAndSetActiveBreacDrumb = (item) => {
        setActiveBreadcrumb(item)
    }

    useEffect(() => {
        dispatch(clearReducer());
        dispatch(cleanAfiliadoSeleccionado());
    }, []);

    return (
        <div className={style.root}>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} styles={{ padding: 5 }}>
                    <CertificadoAtencionBreadCrumb
                        setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
                        activeBreadcrumb={activeBreadcrumb}

                    />
                </Grid>
                {activeBreadcrumb === MENU_CERTIFICADO_ATENCION.INGRESO_CERTIFICADO && (
                    <CertificadoAtencionIngreso

                    />
                )}
                {activeBreadcrumb === MENU_CERTIFICADO_ATENCION.BUSQUEDA_CERTIFICADO && (
                    <CertificadoAtencionBusqueda
                    />
                )}
            </Grid>
        </div>
    )
}
